import { computed, defineComponent, onMounted, ref, useCssModule } from '@nuxtjs/composition-api';
import { parse as parseHTML } from 'node-html-parser';
export default defineComponent({
    name: 'BoxCustomEmbed',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const rootEl = ref();
        const is16x9 = computed(() => {
            const { code } = props.box.data;
            const vendorsPaths = ['youtube.com/embed', 'vkvideo.ru/video_ext.php', 'front.sber.link/aijplayer'];
            for (let i = 0, l = vendorsPaths.length; i < l; i++) {
                if (code.includes(vendorsPaths[i])) {
                    return true;
                }
            }
            return false;
        });
        const embed = parseEmbed(props.box.data.code);
        function parseEmbed(string) {
            if (!string) {
                return {};
            }
            const html = process.server ? parseHTML(string) : new DOMParser().parseFromString(string, 'text/html');
            const embed = {
                html: '',
                links: [],
                scripts: [],
                styles: [],
            };
            const links = html.querySelectorAll('link');
            const scripts = html.querySelectorAll('script');
            const styles = html.querySelectorAll('style');
            if (links.length) {
                for (const node of links) {
                    const attrs = {};
                    for (const { name, value } of Array.from(node.attributes)) {
                        attrs[name] = value;
                    }
                    embed.links.push(attrs);
                    node.remove();
                }
            }
            if (scripts.length) {
                for (const node of scripts) {
                    const attrs = {};
                    if (node.innerHTML) {
                        attrs.innerHTML = node.innerHTML;
                    }
                    for (const { name, value } of Array.from(node.attributes)) {
                        attrs[name] = value;
                        if (name === 'src') {
                            attrs.async = true;
                        }
                    }
                    embed.scripts.push(attrs);
                    node.remove();
                }
            }
            if (styles.length) {
                for (const node of styles) {
                    if (node.innerHTML) {
                        embed.styles.push(node.innerHTML);
                    }
                    node.remove();
                }
            }
            embed.html = process.server ? html.toString() : html.body.innerHTML;
            return embed;
        }
        onMounted(() => {
            if (!rootEl.value && !embed.scripts.length) {
                return;
            }
            for (const script of embed.scripts) {
                if (!script.innerHTML) {
                    continue;
                }
                const scriptEl = document.createElement('script');
                for (const attr in script) {
                    scriptEl[attr] = script[attr];
                }
                setTimeout(() => {
                    rootEl.value?.appendChild(scriptEl);
                    scriptEl.remove();
                }, 500);
            }
        });
        return {
            css,
            embed,
            is16x9,
            rootEl,
        };
    },
});
